import _slicedToArray from "/home/runner/work/spa/spa/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/slicedToArray.js";
var __jsx = React.createElement;
/* eslint-disable quotes */
import React from 'react';
import { connect } from 'react-redux';
import { useTranslation } from 'next-i18next';
import Hamburger from '@spa/shared/svg/hamburger';
import { photoUrl } from '@spa/shared/utils/photos';
import { RENT_TYPE } from '@spa/shared/constants/rentType';
import { PHOTO_SIZES } from '@spa/shared/constants/photos';
import Button from '@spa/shared/components/Unisystem/Button';
import { showModalAction } from '@spa/shared/store/actions/modal';
import { PHOTOS_MODAL_SECTIONS } from '@spa/offer/constants/modals';
import { modalIds } from '@spa/offer/components/Modals/modal-displayer';
import { Wrapper } from './styles';
import { transformFeaturesToCommonFeatures, transformUnitsForSharedSpacesAndAmenities } from '@spa/offer/utils/transformers';
import SimpleCarousel from '@spa/shared/components/SimpleCarousel';
import { trackSeeAllAmenities } from '@spa/offer/store/actions/tracking';
import Placeholder from '@spa/shared/components/Unisystem/Placeholder';
import { transformFeatures } from '@spa/shared/utils/transformers/property';
var SharedSpacesAndAmenities = function SharedSpacesAndAmenities(_ref) {
  var units = _ref.units,
    photos = _ref.photos,
    features = _ref.features,
    rentBy = _ref.rentBy,
    unitId = _ref.unitId,
    showGallery = _ref.showGallery,
    showAmenitiesModal = _ref.showAmenitiesModal;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var transformedUnits = transformUnitsForSharedSpacesAndAmenities(t, units, photos, rentBy);
  var rentByProperty = rentBy === RENT_TYPE.ENTIRE_PROPERTY;
  var commonFeatures = transformFeaturesToCommonFeatures(transformedUnits, transformFeatures(features), unitId, rentByProperty);
  var openAmenitiesModal = function openAmenitiesModal() {
    return showAmenitiesModal({
      commonFeatures: commonFeatures
    });
  };
  return __jsx(Wrapper, null, __jsx(SimpleCarousel, {
    title: rentByProperty ? 'Property features and amenities' : 'Shared spaces and amenities',
    numberOfElements: transformedUnits.length,
    itemWidth: 229,
    gap: 16
  }, transformedUnits.map(function (_ref2) {
    var hash = _ref2.hash,
      unitName = _ref2.unitName,
      unitTypeCode = _ref2.unitTypeCode;
    return hash ? __jsx("div", {
      key: unitName,
      onClick: function onClick() {
        return showGallery(unitName);
      },
      className: "photo"
    }, __jsx("img", {
      src: photoUrl({
        hash: hash,
        size: PHOTO_SIZES.MEDIUM
      }),
      alt: unitName
    }), __jsx("span", null, unitName)) : __jsx("div", {
      key: unitName,
      onClick: openAmenitiesModal,
      className: "placeholder"
    }, __jsx(Placeholder, {
      type: unitTypeCode,
      title: t('No photo yet'),
      subtitle: t("but we're working on it!")
    }), __jsx("span", {
      className: "unit-name"
    }, unitName));
  })), __jsx(Button, {
    isTertiary: true,
    isSmall: true,
    icon: Hamburger,
    iconSide: "left",
    onClick: openAmenitiesModal
  }, t('See all amenities')));
};
var mapStateToProps = function mapStateToProps(_ref3) {
  var _ref3$offer$offerAggr = _ref3.offer.offerAggregate,
    unitId = _ref3$offer$offerAggr.accommodation_offer.property.unit_id,
    _ref3$offer$offerAggr2 = _ref3$offer$offerAggr.property_aggregate.property,
    floors = _ref3$offer$offerAggr2.floors,
    features = _ref3$offer$offerAggr2.features,
    rentBy = _ref3$offer$offerAggr2.lifecycle.rent_by,
    photos = _ref3$offer$offerAggr.photos;
  var _floors = _slicedToArray(floors, 1),
    units = _floors[0].units;
  return {
    units: units,
    photos: photos,
    features: features,
    rentBy: rentBy,
    unitId: unitId
  };
};
var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    showGallery: function showGallery(unitName) {
      return dispatch(showModalAction({
        modalId: modalIds.PHOTOS_MODAL,
        section: PHOTOS_MODAL_SECTIONS.photos.label,
        unitName: unitName
      }));
    },
    showAmenitiesModal: function showAmenitiesModal(features) {
      dispatch(trackSeeAllAmenities());
      dispatch(showModalAction({
        modalId: modalIds.FEATURES,
        features: features
      }));
    }
  };
};
export default connect(mapStateToProps, mapDispatchToProps)(SharedSpacesAndAmenities);